import { Minus, Plus, Trash2 } from "lucide-react";
import ProductPicker from "./ProductPicker";
import { cn } from "@/lib/utils";

const OUTPUTS = [["roti", "Roti Jadi"], ["fd", "Frozen Dough"]];

function QtyInput({ value, onChange, allowNegative, testid }) {
  const step = (d) => onChange(Number(value || 0) + d);
  return (
    <div className="flex h-12 items-stretch overflow-hidden rounded-md border border-zinc-300 bg-white">
      <button type="button" onClick={() => step(-1)} className="press grid w-11 place-items-center hover:bg-zinc-100" data-testid={`${testid}-minus`}><Minus className="h-4 w-4" /></button>
      <input type="number" inputMode="numeric" value={value} min={allowNegative ? undefined : 0} data-testid={testid}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="num w-16 min-w-0 flex-1 border-x border-zinc-200 text-center text-base font-bold focus:outline-none" />
      <button type="button" onClick={() => step(1)} className="press grid w-11 place-items-center hover:bg-zinc-100" data-testid={`${testid}-plus`}><Plus className="h-4 w-4" /></button>
    </div>
  );
}

export default function LinesEditor({ lines, setLines, products, filter, withOutput, allowNegative, unitHint, testid = "lines" }) {
  const update = (i, patch) => setLines(lines.map((l, j) => (j === i ? { ...l, ...patch } : l)));
  const remove = (i) => setLines(lines.filter((_, j) => j !== i));
  const add = () => setLines([...lines, { product_id: "", qty: 1, output: "roti" }]);
  return (
    <div className="space-y-3" data-testid={testid}>
      {lines.map((l, i) => {
        const p = products?.find((x) => x.id === l.product_id);
        return (
          <div key={i} className="rounded-lg border border-zinc-200 bg-zinc-50/60 p-3" data-testid={`${testid}-row-${i}`}>
            <div className="flex flex-col gap-2 sm:flex-row">
              <div className="flex-1"><ProductPicker products={products} value={l.product_id} onChange={(v) => update(i, { product_id: v })} filter={filter} testid={`${testid}-product-${i}`} showStock /></div>
              <div className="flex gap-2 sm:w-56">
                <div className="flex-1"><QtyInput value={l.qty} onChange={(v) => update(i, { qty: v })} allowNegative={allowNegative} testid={`${testid}-qty-${i}`} /></div>
                <button type="button" onClick={() => remove(i)} disabled={lines.length === 1} data-testid={`${testid}-remove-${i}`}
                  className="press grid h-12 w-12 place-items-center rounded-md border border-zinc-300 text-zinc-500 hover:border-brand hover:text-brand disabled:opacity-30"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
              {withOutput ? (
                <div className="flex gap-1.5">
                  {OUTPUTS.map(([v, label]) => (
                    <button key={v} type="button" onClick={() => update(i, { output: v })} data-testid={`${testid}-output-${v}-${i}`}
                      className={cn("press rounded-full border px-3 py-1.5 text-xs font-semibold", l.output === v ? "border-ink bg-ink text-white" : "border-zinc-300 bg-white")}>
                      {label}
                    </button>
                  ))}
                </div>
              ) : <span />}
              {p && unitHint && <span className="text-[11px] text-zinc-500">{unitHint(p, Number(l.qty || 0))}</span>}
            </div>
          </div>
        );
      })}
      <button type="button" onClick={add} data-testid={`${testid}-add`}
        className="press w-full rounded-lg border-2 border-dashed border-zinc-300 py-3 text-sm font-semibold text-zinc-600 hover:border-ink hover:text-ink">
        + Tambah baris produk
      </button>
    </div>
  );
}

export const cleanLines = (lines) => lines.filter((l) => l.product_id && Number(l.qty) !== 0).map((l) => ({ ...l, qty: Number(l.qty) }));
